import "./App.css";

import HexxaTechLandingPage from "./HexxaTechLandingPage";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import { HelmetProvider } from "react-helmet-async";

import CaseStudiesIndex from "./pages/CaseStudiesIndex";
import Cartattva from "./pages/case-studies/Cartattva";
import Swasthya from "./pages/case-studies/Swasthya";
import InventoryManagement from "./pages/case-studies/InventoryManagement";
import ProcessControl from "./pages/case-studies/ProcessControl";
import Satellites from "./pages/case-studies/Satellites";
import WiseTech from "./pages/case-studies/wisetech";

import Header from "./components/Header";
import HashScrollHandler from "./components/HashScrollHandler";
import GoogleAnalytics from "./components/GoogleAnalytics";

import CustomSoftwareDevelopment from "./pages/services/CustomSoftwareDevelopment";
import ERPBusinessManagement from "./pages/services/ERPBusinessManagement";
import CRMLeadManagement from "./pages/services/CRMLeadManagement";
import HealthcareSoftware from "./pages/services/HealthcareSoftware";
import InventoryManagementService from "./pages/services/InventoryManagement";
import IndustrialProcessSoftware from "./pages/services/IndustrialProcessSoftware";
import LicenseManagement from "./pages/services/LicenseManagement";
import MobileAppDevelopment from "./pages/services/MobileAppDevelopment";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>

        {/* Google Analytics */}
        <GoogleAnalytics />

        {/* Header */}
        <Header />

        {/* Hash Scroll Handler */}
        <HashScrollHandler />

        {/* Global Toast Container */}
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />

        <Routes>

          {/* Homepage */}
          <Route
            path="/"
            element={<HexxaTechLandingPage />}
          />

          <Route
            path="/services"
            element={<HexxaTechLandingPage />}
          />

          <Route
            path="/services/custom-software-development"
            element={<CustomSoftwareDevelopment />}
          />

          <Route
            path="/services/erp-business-management"
            element={<ERPBusinessManagement />}
          />

          <Route
            path="/services/crm-lead-management"
            element={<CRMLeadManagement />}
          />

          <Route
            path="/services/healthcare-software"
            element={<HealthcareSoftware />}
          />

          <Route
            path="/services/inventory-management"
            element={<InventoryManagementService />}
          />

          <Route
            path="/services/industrial-process-software"
            element={<IndustrialProcessSoftware />}
          />

          <Route
            path="/services/license-management"
            element={<LicenseManagement />}
          />

          <Route
            path="/services/mobile-app-development"
            element={<MobileAppDevelopment />}
          />

          {/* Case Studies */}
          <Route
            path="/case-studies"
            element={<CaseStudiesIndex />}
          />

          <Route
            path="/case-studies/cartattva"
            element={<Cartattva />}
          />

          <Route
            path="/case-studies/swasthya"
            element={<Swasthya />}
          />

          <Route
            path="/case-studies/wisetech"
            element={<WiseTech />}
          />

          <Route
            path="/case-studies/inventory-management"
            element={<InventoryManagement />}
          />

          <Route
            path="/case-studies/process-control"
            element={<ProcessControl />}
          />

          <Route
            path="/case-studies/satellites"
            element={<Satellites />}
          />

        </Routes>

      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;